import React from "react";

import FullLogoIcon from "@/assets/svg/fullLogo.svg?react";
import { cn } from "@/helpers/tailwind";

interface InfiniteDripitLoaderProps {
  shouldHide?: boolean;
}

export const InfiniteDripitLoader: React.FC<InfiniteDripitLoaderProps> = ({
  shouldHide = false,
}) => (
  <div
    className={cn(
      "flex items-center justify-center bg-background opacity-100",
      "absolute left-0 top-0 z-50 h-screen w-full",
      "transition-all duration-300 ease-in-out",
      { "pointer-events-none opacity-0": shouldHide }
    )}>
    <FullLogoIcon className="animate-float" />
  </div>
);
